export default __webpack_public_path__ + "static/media/ferramenta-baixar-videos-img6.167b49c5.jpeg";